import { Media, Texts, Button } from "../Object";
import { Grid } from "../Layout";
import { useState, useEffect, useMemo } from "react";
import { useDocumentLoadCompleted, useInterval } from "../Hooks";
import { Scroll } from '../Animation';

const Fv = () => {
  const [viewIndex, setViewIndex] = useState(0);
  let delay = 8000;
  const isLoaded = useDocumentLoadCompleted();

  const gridProps = {
    content: {
      dir: "row",
      gap: [`${(80 / 1920) * 100}vw`, 40],
      class: "c-fv__wrap--content",
      layout: ["100%"],
    },
    wrap: {
      dir: ["column", "row"],
      gap: [`${(80 / 1920) * 100}vw`, 40],
      layout: ["64.375% 1fr", "100%"],
      class: "c-fv__wrap",
    },
    body: {
      dir: "row",
      gap: [(64 / 1920) * 100 + "vw", 48],
      layout: ["100%"],
      class: 'c-fv__wrap--body'
    },
  };

  // カウンター関数
  const CounterStart = useInterval(() => {
    let index = viewIndex; // indexを取得
    let maxNum = 2; // indexの最高値
    if (index == maxNum) {
      // 現在のindexが最高値だった場合、indexを0に戻す
      index = 0; // indexの初期化
    } else {
      index = index + 1; // indexの増加
    }
    setViewIndex(index); // stateに登録
  }, delay);

  useEffect(() => {
    // 全ての要素をロードした後にカウンター開始
    if (isLoaded) {
      CounterStart;
    }
  }, [isLoaded]);

  // elment

  const CatchCopy = (props) => {
    return (
      <>
        {props.index == viewIndex && 
          <Scroll>
            <Texts slug={`catch/list${props.index}`}></Texts>
          </Scroll>
        }
      </>
    );
  };
  
  let CatchCopyItems = [];
  for (let i = 0; i < 3; i++) {
    CatchCopyItems.push(<CatchCopy key={i} index={i}></CatchCopy>)
  }

  const Logo = () => {
    return (
      <>
        <Media
          src="common/icon-logo"
          alt="logo-image"
          class="c-fv__img--logo"
          pClass={isLoaded ? "c-fv__img--logo__wrap--loaded" : ""}
          sp="sp"
        ></Media>
      </>
    );
  };
  const LogoMemo = useMemo(() => <Logo />, [isLoaded]);
  
  const CatchImg = () => {
    return (
      <>
        <Media
          src="common/catch"
          alt="One's Planning For Keep Fine --- 快適に暮らし続けるために"
          class="c-fv__img--catch"
          pClass={isLoaded ? "c-fv__img--catch__wrap--loaded" : ""}
          sp="sp"
        ></Media>
      </>
    );
  }
  const CatchImgMemo = useMemo(() => <CatchImg/>, [isLoaded]);
  
  const FvItem = (props) => {
    let active = "";
    if (viewIndex == props.index && isLoaded) {
      active = "active";
    } else {
      active = "anactive";
    }
    return (
      <>
        <li className="c-fv__items" data-state={active}>
          <Media
            class="c-fv__img--fv"
            src={`fv/list${props.index}`}
            alt="fv"
            sp="sp"
          ></Media>
        </li>
      </>
    );
  };

  let fvItems = [];
  for (let i = 0; i < 3; i++) {
    fvItems.push(<FvItem key={i} index={i}></FvItem>);
  }

  return (
    <>
      <Grid {...gridProps.wrap}>
        <ul className="c-fv__list">{fvItems}</ul>

        <Grid {...gridProps.content}>
          { LogoMemo }
          <Grid {...gridProps.body}>
            { CatchImgMemo }
            { CatchCopyItems }
            <Button slug="company" link="/about" type="normal"></Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Fv;
